import type { ReactNode } from 'react';

import { AppContext } from './AppContext';
import type { AppDefinition } from './contracts';

interface AppProviderProps {
  app: AppDefinition;
  children: ReactNode;
}

/** Exposes the current dashboard definition to the tree (see `useApp`). */
export function AppProvider({ app, children }: AppProviderProps) {
  return <AppContext.Provider value={app}>{children}</AppContext.Provider>;
}
